import IEmittedEvent from "../types/IEmittedEvent";
import { EVENT_TYPES } from "../types/EventTypes";

class EventEmitter {
  debug: boolean = false;
  events: {
    [key in EVENT_TYPES]: Array<(callback: (arg0: any) => any) => void>;
  } = {
    newBatchInstances: [],
    newBatchClassConfigs: [],
    changeDocument: [],
    changeBatchInstance: [],
    changeBatchClassConfig: [],
    highlightCoordinates: [],
    tableHighlight: [],
    wipeDocument: [],
    modelUpdated: [],
    tableModelUpdated: [],
    dlfRuleChanged: [],
    DB_waiting: [],
    DB_yesNoQuery: [],
    DB_confirm: [],
    documentViewerPopped: [],
    deleteBatchInstance: [],
    processBatchInstance: [],
    finishProcessingBatchInstance: [],
    focusNewModel: [],
    deleteModel: [],
    loadedModel: [],
    focusModelCleared: [],
    docTypeChanged: [],
    documentBoundaryRulesChanged: [],
    columnWidthsChanged: [],
    loadedModelImage: [],
    IB_createModel: [],
    IB_select: [],
    DB_kill_open: [],
    modelSaved: [],
    modelNameChanged: [],
    authenticationError: [],
  };

  constructor() {}

  publish(data: IEmittedEvent) {
    if (this.debug) {
      console.log(`Publishing event %c${data.name}`, "font-family: monospace");
    }
    if (!this.events[data.name]) return;
    this.events[data.name].forEach((callback: any) => {
      try {
        callback(data.val);
      } catch (e) {
        if (this.debug) console.log(e);
      }
      return;
    });
  }

  subscribe(
    name: EVENT_TYPES,
    callback: (arg0: any) => any,
  ): { name: EVENT_TYPES; cb: Function } {
    if (!this.events[name]) this.events[name] = [];
    this.events[name].push(callback);
    return { name, cb: callback };
  }

  unsubscribe(name: EVENT_TYPES, callback: Function) {
    if (!this.events[name]) this.events[name] = [];
    this.events[name] = this.events[name].filter((x) => x != callback);
  }

  unsubscribeAll() {
    Object.keys(this.events)
      .map((x: string) => ({
        name: x as EVENT_TYPES,
        events: this.events[x as EVENT_TYPES],
      }))
      .forEach((x) =>
        x.events.forEach((e) => eventEmitter.unsubscribe(x.name, e)),
      );
  }
}

const eventEmitter = new EventEmitter();

export default eventEmitter;
